import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";
import { TCampaignsPaginated } from "../types";

export const QUERY_KEY_CAMPAIGNS = "admin-marketing-campaigns";

const getData = async (props: {
  token: string;
  page: number;
  search?: string;
  is_active?: string;
  target_type?: string;
}): Promise<TCampaignsPaginated> => {
  const params: Record<string, string> = {
    page: String(props.page),
    per_page: "15",
  };
  if (props.search) params.search = props.search;
  if (props.is_active !== undefined && props.is_active !== "") {
    params.is_active = props.is_active;
  }
  if (props.target_type) params.target_type = props.target_type;

  const url = `${END_POINT.BASE_URL}/v1/administrator/campaigns`;
  const res = await axios.get<TCampaignsPaginated>(url, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
    params,
  });
  return res.data;
};

export const useGetCampaigns = (
  page: number,
  search?: string,
  is_active?: string,
  target_type?: string
) => {
  const { token } = useGetUserInfo();
  return useQuery(
    [QUERY_KEY_CAMPAIGNS, page, search ?? "", is_active ?? "", target_type ?? ""],
    () =>
      getData({
        token,
        page,
        search,
        is_active,
        target_type,
      }),
    { keepPreviousData: true }
  );
};
